import { modelStats } from "routes/facilities/controller/model-stats"

export function useModelStats(group) {
    return modelStats.useResults(group)
}
